// extracted by mini-css-extract-plugin
module.exports = {"box-loader":"box-loader--2JiBK","-white":"-white--2U4sa","-grey":"-grey--4XuMf","-darkgrey":"-darkgrey--8aBJL","loader":"loader--rhSkY"};